import React from 'react';

class Logo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="mole-logo-txt">Mole</div>
        );
    }
}
export default Logo;



// WEBPACK FOOTER //
// ./src/components/inc/Logo.js